import { useState } from 'react';

export type SortingOptions<ObjectToSort extends Record<string, unknown>> = {
    sortByKey: keyof ObjectToSort | undefined;
    sortDirection: 'ASC' | 'DESC';
};

interface UseSortingProps<ObjectToSort extends Record<string, unknown>> {
    defaultSortByKey: SortingOptions<ObjectToSort>['sortByKey'];
    defaultSortDirection: SortingOptions<ObjectToSort>['sortDirection'];
}

export function useSorting<ObjectToSort extends Record<string, unknown>>(props: UseSortingProps<ObjectToSort>) {
    const [sortingOptions, setSortingOptions] = useState<SortingOptions<ObjectToSort>>({
        sortByKey: props.defaultSortByKey,
        sortDirection: props.defaultSortDirection,
    });

    const handleSort = (key: keyof ObjectToSort) => {
        if (sortingOptions?.sortByKey === key) {
            if (sortingOptions.sortDirection === 'ASC') {
                setSortingOptions((prev) => ({ ...prev, sortByKey: key, sortDirection: 'DESC' }));
            }

            if (sortingOptions.sortDirection === 'DESC') {
                setSortingOptions((prev) => ({ ...prev, sortByKey: key, sortDirection: 'ASC' }));
            }
        }

        setSortingOptions((prev) => ({ ...prev, sortByKey: key }));
    };

    return { handleSort, sortingOptions };
}
